import { EditorState, ContentState, Entity } from 'draft-js';

export function updateEntity({ entityKey, getEditorState, setEditorState, update }) {
	/** @type {EditorState} */
	const editorState = getEditorState();
	const contentState = editorState.getCurrentContent();
	const selection = editorState.getSelection();
	const entity = contentState.getEntity(entityKey);
	if (entity) {
		contentState.mergeEntityData(entityKey, update);
		// force update workaround at https://github.com/facebook/draft-js/issues/458#issuecomment-225710311
		setEditorState(
			EditorState.forceSelection(
				EditorState.createWithContent(contentState, editorState.getDecorator()),
				selection,
			),
			true,
		);
	}
}



// WEBPACK FOOTER //
// ./lib/helpers/updateEntity.js